module.exports = __webpack_public_path__ + "static/media/source_online.7a7e248b.svg";